<template>
  <zm-drawer :footer="false" size="large" :title="title" :width="drawerWidth" :visible="visible" @cancel="open(false)">
    <div slot="drawerBody">
      <div class="title">产品信息</div>
      <a-row :gutter="24">
        <a-col :md="5">
          <span class="title_1">产品编号</span>
          <span>{{ model.productNumber }}</span>
        </a-col>
        <a-col :md="5">
          <span class="title_1">产品名称</span>
          <span>{{ model.productName }}</span>
        </a-col>
        <a-col :md="5">
          <span class="title_1">产品线</span>
          <span>{{ model.productLine }}</span>
        </a-col>
      </a-row>
      <a-divider style="margin: 16px 0"></a-divider>
      <div class="title">销售记录</div>
      <a-table :columns="table.columns" :data-source="table.data">
        <template slot="num" slot-scope="text, record, index">
          {{ index + 1 }}
        </template>
      </a-table>
    </div>
  </zm-drawer>
</template>

<script>
import { getProductSale } from '@/api/product'
export default {
  data() {
    return {
      title: '销售记录',
      width: 1000,
      visible: false,
      table: {
        data: [],
        columns: [
          {
            title: '序号',
            scopedSlots: {
              customRender: 'num',
            },
          },
          {
            title: '项目名称',
            dataIndex: 'projectName',
          },
          {
            title: '产品总价(元)',
            dataIndex: 'totalPrice',
          },
          {
            title: '签约日期',
            dataIndex: 'contractDate',
          },
          {
            title: '甲方名称',
            dataIndex: 'partyName',
          },
          {
            title: '产品功能',
            dataIndex: 'modulesName',
          },
        ],
      },
      model: {},
    }
  },
  computed: {
    drawerWidth() {
      const width = window.innerWidth - 200
      return width
    },
  },
  methods: {
    // 打开or关闭，修改的窗口先获取详情
    open(flag) {
      // this.formClear()
      this.visible = flag
      // this.getModelInfo(this.model) 通过接口获取详情
    },
    async setModel(model) {
      this.model = model
      const res = await getProductSale({ queryProductId: this.model.id, jpaging: true }).catch((err) => {
        console.log('初始化失败', err)
      })
      if (res && res.status === 0) {
        this.table.data = res.data.list
      }
    },
  },
}
</script>

<style scoped>
.title {
  font-weight: bold;
  margin-bottom: 10px;
}
.title::before {
  display: inline-block;
  width: 4px;
  height: 12px;
  background: #1791ff;
  content: '';
  margin-right: 7px;
}
.title_1 {
  color: #b3b3b3;
  margin-right: 12px;
}
</style>
